const CAP27 = {
  "id": 50,
  "title": "Legalidad de Bitcoin en México y el mundo",
  "slug": "legalidad-de-bitcoin-en-mexico-y-el-mundo",
  "type": "lesson",
  "category": "bitcoin",
  "level": "basic",
  "sections": [
    {
      "heading": "¿Bitcoin es legal?",
      "text": [
        "Actualmente, en la mayoría de países del mundo, Bitcoin es legal o está permitido su uso, aunque con diferentes niveles de regulación.",
        "Sin embargo, en algunos países su uso ha sido restringido o prohibido. Aun así, esas prohibiciones no han impedido completamente su uso, ya que Bitcoin es una red global y descentralizada.",
        "La legalidad de Bitcoin depende del tratamiento que cada país le da, si lo considera activo financiero, moneda virtual, propiedad digital o incluso medio de pago."
      ]
    },
    {
      "heading": "Bitcoin y la moneda de curso legal",
      "text": [
        "Es importante diferenciar entre 'Bitcoin es legal' y 'Bitcoin es moneda de curso legal'.",
        "Una moneda de curso legal es aquella que los ciudadanos están obligados a aceptar como medio de pago y que está respaldada por un banco central.",
        "Bitcoin solo es considerado moneda de curso legal oficialmente en:",
        "• El Salvador (desde 2021)\n• República Centroafricana (desde 2022)",
        "En algunos estados de Estados Unidos, como Ohio y Colorado, permiten pagar impuestos con Bitcoin, pero no se considera moneda de curso legal a nivel nacional."
      ]
    },
    {
      "heading": "Legalidad de Bitcoin en México",
      "text": [
        "En México, Bitcoin no es moneda de curso legal, pero su uso es legal y está permitido.",
        "La Ley Fintech (2018) reconoce a Bitcoin y otras criptomonedas como ‘activos virtuales’.",
        "Se permite su compra, venta, intercambio, uso en pagos y comercio electrónico, bajo ciertas condiciones.",
        "Están permitidos los exchanges regulados y supervisados por la Comisión Nacional Bancaria y de Valores (CNBV).",
        "Las empresas que operan con criptomonedas pueden estar sujetas a obligaciones de prevención de lavado de dinero (PLD) y deben reportar operaciones al SAT."
      ],
      "list": [
        "Bitcoin no es ilegal.",
        "No es moneda oficial de México.",
        "Sí se puede usar como medio de pago voluntario entre particulares y comercios.",
        "Debe declararse ante el SAT si genera ganancias.",
        "Los exchanges autorizados están regulados por la Ley Fintech."
      ]
    },
    {
      "heading": "Países donde Bitcoin está prohibido",
      "text": [
        "En estos países, Bitcoin ha sido declarado ilegal o su uso se encuentra fuertemente prohibido por ley."
      ],
      "list": [
        "Afganistán",
        "Pakistán",
        "Argelia",
        "Bolivia",
        "Bangladesh",
        "China",
        "Arabia Saudí",
        "Egipto",
        "Nepal",
        "Qatar",
        "Vanuatu",
        "Vietnam"
      ]
    },
    {
      "heading": "Países donde Bitcoin está limitado o parcialmente permitido",
      "text": [
        "En estos países, Bitcoin no es ilegal, pero su uso está restringido o bajo supervisión especial, con limitaciones para intercambios, minería o uso comercial."
      ],
      "list": [
        "Canadá",
        "Costa Rica",
        "Camboya",
        "India",
        "Ecuador",
        "Indonesia",
        "Jordania",
        "Marruecos",
        "Namibia",
        "Zambia",
        "Nigeria",
        "Rusia",
        "Samoa Americana",
        "Taiwan",
        "Tailandia"
      ]
    },
    {
      "heading": "Situación en Estados Unidos",
      "text": [
        "Bitcoin es legal en Estados Unidos, pero su regulación varía según cada estado.",
        "La SEC, IRS y CFTC clasifican a Bitcoin como activo digital, propiedad y commodity respectivamente.",
        "Es legal pagar con Bitcoin, invertir en él y usarlo para servicios financieros, siempre que se cumplan las regulaciones.",
        "Algunos estados permiten pagar impuestos con Bitcoin, como Ohio y Colorado."
      ]
    },
    {
      "heading": "Situación en Europa",
      "text": [
        "En la Unión Europea, Bitcoin no es moneda de curso legal, pero está permitido su uso y compra.",
        "La Comisión Europea está desarrollando MiCA (Reglamento de Mercados en Criptoactivos) para regular todos los criptoactivos.",
        "Bitcoin se considera un activo financiero digital.",
        "Los países donde Bitcoin tiene mayor adopción legal son Alemania, Suiza, Portugal y Reino Unido."
      ]
    },
    {
      "heading": "Uso entre empresas y comercios",
      "text": [
        "En la mayoría de países es legal que una empresa o comercio acepte Bitcoin como método de pago, siempre que exista voluntad entre comprador y vendedor.",
        "Bitcoin se puede usar como medio de intercambio, aunque no sea moneda oficial del país.",
        "Miles de empresas como Microsoft, Starbucks, PayPal, Mercado Libre y algunas tiendas físicas aceptan pagos con Bitcoin o lo permiten a través de procesadores como BitPay o Strike."
      ]
    },
    {
      "heading": "Mensaje final",
      "text": [
        "Bitcoin no está prohibido en la mayoría de los países. Su estatus legal varía desde activo digital, propiedad privada, dinero virtual o incluso moneda de curso legal en algunos pocos países.",
        "Su aceptación legal está aumentando, pero aún existe mucha diversidad en cómo los países lo regulan.",
        "Bitcoin abre la puerta a una economía global sin fronteras, pero es fundamental entender su situación legal según cada país."
      ]
    }
  ]
};

export default CAP27;
